module.exports = __webpack_public_path__ + "img/toscania.9c1d5670.jpg";